
export const MomentConfiguration = {
  spanish: {
    language: 'es',
    months: {
      monthsShort: 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic'.split('_'),
      monthsParseExact: true
    }
  }
};
